<!-- End Navbar -->
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary" style="height: 3.75rem">
            <h4 class="card-title ">{{sociedad}}</h4>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" [pageSize]="pageSize" [pageIndex]="currentPage - 1"
            [length]="totalItems" (page)="onPageChange($event)">
          </mat-paginator>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <th>ID. {{ 'texto_132' | translate }}</th>
                  <th>N. {{ 'texto_132' | translate }}</th>
                  <th>{{ 'texto_95' | translate }}</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of fases">
                    <td>{{ item.id_fase }}</td>
                    <td>{{ item.n_fase }}</td>
                    <td>{{ item.comentario }}</td>
                    <td class="td-actions text-right" style="width:90px;">
                      <button (click)="showCenter(item)" type="button" rel="tooltip" title="Edit Center" class=""
                        style="background: none;color:black;border:none;">
                        <i class="material-icons">edit</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br><br>
              <!-- Modal -->
              <div [style.display]="IsHiddenForm ? 'block' : 'none'" class="modal" tabindex="-1">
                <div class="modal-dialog cascading-modal modal-avatar modal-sm">
                  <div class="modal-content">
                    <form [formGroup]="validatingForm">
                      <div class="modal-body mx-3">
                        <div class="card-header card-header-info">
                          <h5 class="card-title mb-0">{{ 'texto_707' | translate }}</h5>
                        </div>

                        <button type="button" style="z-index: 100; position: absolute; top: 0px; right: 10px;"
                          class="btn btn-dark btn-sm" data-dismiss="modal" (click)="hideModal()"
                          aria-label="Cerrar modal">X</button>

                        <!-- ID -->
                        <div class="md-form mb-3">
                          <input type="text" class="form-control" formControlName="signupFormModalId" mdbInput
                            mdbValidate readonly>
                          <label>ID. {{ 'texto_132' | translate }}</label>
                        </div>

                        <!-- Nombre -->
                        <div class="md-form mb-3">
                          <input type="text" class="form-control" formControlName="signupFormModalName" mdbInput
                            mdbValidate maxlength="255">
                          <label>N. {{ 'texto_132' | translate }}</label>
                          <mdb-error
                            *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
                            {{ 'texto_61' | translate }}
                          </mdb-error>
                          <mdb-success
                            *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
                            {{ 'texto_62' | translate }}
                          </mdb-success>
                        </div>

                        <!-- Comentario -->
                        <div class="md-form">
                          <mdb-icon fas icon="pencil-alt" class="prefix grey-text"></mdb-icon>
                          <textarea class="md-textarea form-control" rows="5" formControlName="contactFormModalMessage"
                            mdbInput maxlength="4000"></textarea>
                          <label>{{ 'texto_46' | translate }}</label>
                          <mdb-error
                            *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
                            {{ 'texto_61' | translate }}
                          </mdb-error>
                          <mdb-success
                            *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
                            {{ 'texto_62' | translate }}
                          </mdb-success>
                        </div>

                        <!-- Botón de guardar -->
                        <div class="text-center mt-3">
                          <button (click)="updatePhase(signupFormModalId.value)" mdbBtn rounded="true"
                            class="btn-primary mt-1 waves-light" mdbWavesEffect [disabled]="!validatingForm.valid">
                            {{ 'texto_59' | translate }}
                          </button>
                        </div>

                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- Fin modal -->


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
